import React from "react"
import { getCompiler } from "utils/MarkdownCompile"
/* eslint-disable import/no-restricted-paths */
import { components, elements } from "../DefaultMarkdown"
/* eslint-enable import/no-restricted-paths */
import { TextLink } from "components/views/atoms/links/TextLink"
import { ZendeskTextLink } from "../atoms/links/ZendeskTextLink"
import { isZendeskLink } from "carrot-api/HelpCenterClient"

function A({ href, title, children }): JSX.Element {
  if (isZendeskLink(href)) {
    return (
      <ZendeskTextLink target={"_blank"} title={title} to={href}>
        {children}
      </ZendeskTextLink>
    )
  }

  return (
    <TextLink target="_blank" title={title} to={href}>
      {children}
    </TextLink>
  )
}
const requestCardElements = {
  ...elements,
  a: A
}

const md = getCompiler(requestCardElements, components)

type RequestCardInformationMarkdownProps = {
  additionalClasses?: string
  source: string
}

function RequestCardInformationMarkdown({
  additionalClasses,
  source
}: RequestCardInformationMarkdownProps): JSX.Element {
  return <div className={`m0-first-last-child ${additionalClasses ? additionalClasses : ""}`}>{md(source)}</div>
}

export { RequestCardInformationMarkdown }
